
import { AxiosHelper } from '../helpers/AxiosHelper';


const GetTotalizers = async (formData: FormData) => {
    return AxiosHelper.post('/ServiceOrderTag/GetTotalizers', formData);
}


const ServiceOrderTagService = {
    GetTotalizers
}

export default ServiceOrderTagService;